import { render, staticRenderFns } from "./pv.vue?vue&type=template&id=1c4ba075&scoped=true&"
import script from "./pv.vue?vue&type=script&lang=js&"
export * from "./pv.vue?vue&type=script&lang=js&"
import style0 from "./pv.vue?vue&type=style&index=0&id=1c4ba075&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4ba075",
  null
  
)

export default component.exports